import { defineMessages } from "react-intl";

export const messages = defineMessages({
	userProfile: {
		id: "form.user_profile",
		defaultMessage: "Felhasználói profil"
	},
	personalDetails: {
		id: "form.user_profile.personal_details",
		defaultMessage: "Személyes adatok"
	},
	securityDetails: {
		id: "form.user_profile.security_details",
		defaultMessage: "Biztonsági adatok"
	},
	success: {
		id: "form.user_profile.success",
		defaultMessage: "A profil módosítása sikeresen megtörtént"
	},
	title: {
		id: "form.user_profile.title",
		defaultMessage: "Titulus"
	},
	firstName: {
		id: "form.user_profile.first_name",
		defaultMessage: "Keresztnév"
	},
	lastName: {
		id: "form.user_profile.last_name",
		defaultMessage: "Vezetéknév"
	},
	phoneNumber: {
		id: "form.user_profile.phone_number",
		defaultMessage: "Telefonszám"
	},
	occupation: {
		id: "form.user_profile.occupation",
		defaultMessage: "Foglalkozás"
	},
	stampNumber: {
		id: "form.user_profile.stamp_number",
		defaultMessage: "Pecsétszám"
	},
	language: {
		id: "form.user_profile.language",
		defaultMessage: "Nyelv"
	},
	currentPassword: {
		id: "form.user_profile.current_password",
		defaultMessage: "Jelenlegi jelszó"
	},
	newPassword: {
		id: "form.user_profile.new_password",
		defaultMessage: "Új jelszó"
	},
	newPasswordAgain: {
		id: "form.user_profile.new_password_again",
		defaultMessage: "Jelszó újra"
	}
});
